<template>
    <div>
         <div>
            <div v-for="(item,i) of data" :key="i" @click="tiao1(i)" >
             <div class="li" :class="active==i?'activeli':''">
               <span class="sanjiao"></span>{{item.gtypeName}}
             </div>
             <!-- <div class="li1" :style="active==i?'':'height:0px'">
                 <div v-for="(ite,m) of item.goods" :key="m" @click.stop="tiao(ite.gtype,ite.id)" :style="id==ite.id?'color:red':''"><span class="sanjiaob"></span>{{ite.name}}({{ite.modName}})</div>
             </div> -->
           </div>
         </div>

         <div class="lian">
                 <div>联系我们</div>
                    <pre>
       
       联系人：韩先生
                      
       手机号：13391633268

       电  话：010-56268817

       传  真：010-89351791

       地  址：北京房山区天星街
              1号院14号楼1206
                </pre>
        </div>
     </div> 
</template>
<script>
export default {
    data(){
        return{
        active:9999,
        id:'',
        data:[],
        }
    },
    methods:{
        tiao(type,id){
        //  this.$router.push('/xiang/chanx/'+id)
          this.$router.push('/xiang/chanx?type='+type+'&id='+id)
        },
        tiao1(id){
          this.active=id
          var type=id+1
          this.$router.push('/chan?type='+type)
        }
    },
    watch: {
	'$route' () {
		if(this.$route.query.type){
            this.active=this.$route.query.type-1
        }else{
            this.active=9999
        }
        if(this.$route.query.id){
            this.id=this.$route.query.id
        }else{
            this.id=""
        }
        this.$forceUpdate();
	}
    },
    created(){
        this.axios.get('goods/all').then((res)=>{this.data=res.data});
        if(this.$route.query.type){
            this.active=this.$route.query.type-1
        }
        if(this.$route.query.id){
            this.id=this.$route.query.id
        }
    }
}
</script>
<style scoped>
 .li{
  /* transition: .8s linear; */
  height: 65px;
  font-size: 14px;
  line-height: 65px;
  box-sizing: border-box;
  padding-left:75px; 
  cursor: pointer;
   background: #f8f5f5;
   position: relative;
 }
.li:hover{
    color: red;
    /* color: white; */
}
.activeli{
    /* background: red; */
    color: red;
}
.activeli .sanjiao{
    border-left: 10px solid red;
}
.li:hover .sanjiao{
    border-left: 10px solid red;
}
.sanjiao{
    position: absolute;
    width: 0;
    height: 0;
    left: 53px;
    top: 28px;
    border-top: 5px solid transparent;
    border-left: 10px solid black;
    border-bottom: 5px solid transparent;
}
.lian{
    margin-top:30px;
    background: #f8f5f5;
    font-size:13px;
}
.lian>div{
    font-size: 16px;
     text-align: center;
     padding: 20px 0;
     background:rgba(224,224,224,1);
border-radius:5px 5px 0px 0px;
 }
.lian>pre{
    margin-top: 2px;
    font-size: 14px;
    color: #221815;
}
/*空心三角 */
.li1{
    overflow: hidden;
    transition: .5s ;
}
.li1>div{
    position: relative;
    height: 30px;
    box-sizing: border-box;
    padding-left: 57px;
    font-size: 12px;
    line-height: 30px;
    cursor: pointer;
}
.sanjiaob{
    position: absolute;
    width: 0;
    height: 0;
    left: 35px;
    top: 10px;
    border-top: 5px solid transparent;
    border-left: 10px solid red;
    border-bottom: 5px solid transparent;
}

.sanjiaob:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    left: -9px;
    top: -4px;
    border-top: 4px solid transparent;
    border-left: 8px solid #fff;
    border-bottom: 4px solid transparent;
}
</style>